<template>
  <div class="anDetail">
    <Header :navIndex="navIndex"></Header>
    <div class="wrap">
      <div class="local">
        您的位置: 首页 > 阁韵案例 >
        <span style="font-weight: 500">{{ title }}</span>
      </div>
      <div class="swiper">
        <div class="title">{{ title }}</div>
        <div class="auth">
          <span class="mr">作者:</span>
          <span class="mr">{{ author }}</span>
          <span class="mr">编辑:</span>
          <span class="mr">{{ editor }}</span>
          <span class="mr">来源:</span>
          <span class="mr">{{ source }}</span>
          <span class="mr">发布日期:</span>
          <span>{{ date }}</span>
        </div>
        <!-- 左切换 -->
        <div class="swiperWrap">
          <div class="arrow" @click="arrowClick('left')">
            <img src="../assets/anli/left.png" alt="" />
          </div>

          <!-- 轮播图 -->
          <div class="swiper">
            <el-carousel
              indicator-position="none"
              ref="cardShow"
              arrow="never"
              :initial-index="activeIndex"
              :autoplay="false"
            >
              <el-carousel-item>
                <div class="contentWrap">
                  <div class="pic">
                    <img :src="`${imagesingle}`" alt="" />
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <!-- 右切换 -->
          <div class="arrow" @click="arrowClick('right')">
            <img src="../assets/anli/right.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <Part5></Part5>
  </div>
</template>

<script>
import Header from "../components/Header";
import Part5 from "../components/Part5";
import { cases, casesDetail } from "../api/request";

export default {
  components: { Header, Part5 },
  name: "anDetail",
  data() {
    return {
      author: "",
      editor: "",
      source: "",
      title: "",
      date: "",
      imagesingle: null,
      // mark: [
      //   "山东德州扒鸡集团",
      //   "莆田翁氏府邸",
      //   "奥利维亚",
      //   "哈公馆",
      //   "盛和天下",
      //   "翠湖天地",
      //   "保利小区",
      //   "观江国际",
      //   "世纪花园",
      //   "碧水庄园",
      //   "辰能溪树庭院",
      //   "观复国际",
      //   "海富山水文园 ",
      //   "华侨丽景",
      //   "龙之港",
      //   "盟科时代",
      // ],
      activeIndex: 0,
      navIndex: 6,
      imglist: [],
      listIndex: 0,
      list: [],
      // 下一个id (假设1 德州扒鸡)
      nextid: null,

      // 上一个id
      previd: null,
    };
  },
  mounted() {
    cases().then((res) => {
      if (res.data.code == 1) {
        // console.log(res.data.data);
        // this.imglist = res.data.data;
      }
    });

    // 传过来的id
    // console.log(this.$route.params.id);
    // 下一个id
    // console.log(this.$route.params.nextid);
    this.previd = this.$route.params.previd;
    this.nextid = this.$route.params.nextid;
    // 上一个id
    // console.log(this.$route.params.previd);
    // 传过来的数据
    // console.log(this.$route.params.item);
    this.list = this.$route.params.item;
    this.title = this.$route.params.item.title;
    this.author = this.$route.params.item.author;
    this.editor = this.$route.params.item.editor;
    this.source = this.$route.params.item.source;
    this.imagesingle = this.$route.params.item.image;
    // this.date = this.$route.params.item.createtime;

    this.date = this.timestampToTime(this.$route.params.item.createtime);

    // this.listIndex = this.$route.params.id - 1;
    // this.activeIndex = this.$route.params.id - 1;
  },
  methods: {
    // 转时间戳
    timestampToTime(timestamp) {
      if (timestamp === 0 || timestamp == null) {
        return "";
      } else {
        var date = new Date(timestamp * 1000);
        var Y = date.getFullYear() + ".";
        var M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + ".";
        var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        return Y + M + D;
      }
    },

    change() {
      // console.log(index);
      // this.listIndex = index;
    },
    changePrev() {
      // console.log("上一个");
    },
    changeNext() {
      // console.log("下一个");
    },
    // changeSwiper(index) {
    //   // console.log(index)
    //   this.index = index;
    //   this.$refs.cardShow.setActiveItem(index - 2);
    // },
    arrowClick(val) {
      // console.log(item);
      if (val === "right") {
        // console.log(val);
        // this.$refs.cardShow.next();

        casesDetail({ id: this.nextid }).then((res) => {
          if (res.data.code == 1) {
            console.log(res.data.data);
            console.log("you");

            this.previd = res.data.data.next_id;
            this.nextid = res.data.data.pre_id;
            this.title = res.data.data.title;
            this.author = res.data.data.author;
            this.editor = res.data.data.editor;
            this.source = res.data.data.source;
            this.imagesingle = res.data.data.image;
            this.date = this.timestampToTime(res.data.data.createtime);
            console.log(this.previd);
          }
        });

        // this.$refs.cardShow.next();
      } else {
        // console.log(this.nextid);
        casesDetail({ id: this.previd }).then((res) => {
          if (res.data.code == 1) {
            // console.log(res.data.data);
            // console.log("zuo");

            this.title = res.data.data.title;
            this.previd = res.data.data.next_id;
            this.nextid = res.data.data.pre_id;

            this.author = res.data.data.author;
            this.editor = res.data.data.editor;
            this.source = res.data.data.source;
            this.imagesingle = res.data.data.image;
            this.date = this.timestampToTime(res.data.data.createtime);
          }
        });

        // 上一张
        // this.$refs.cardShow.prev();
      }
    },
  },
};
</script>

<style scoped lang="less">
.anDetail {
  .mr {
    margin-right: 10px;
  }

  font-family: 微软雅黑, MicrosoftYaHei;
  .wrap {
    background: #f5f5f5;
  }
  .local {
    padding: 61px 0 52px;
    width: 1280px;
    margin: 0 auto;
    text-align: left;
    color: #004c31;
    font-size: 24px;
  }
  .swiper {
    padding: 1px;
    width: 1280px;
    margin: 0 auto;
    background: #ffffff;
    .title {
      text-align: left;
      margin: 45px 0 0 40px;
      font-size: 32px;
      font-weight: bold;
      color: #004c31;
    }
    .auth {
      padding: 23px 0 31px 40px;
      text-align: left;
      font-size: 14px;
      font-weight: 400;
      color: #6c7a77;
      border-bottom: 1px dotted #f5f5f5;
    }
    .swiperWrap {
      width: 1063px;
      height: 625px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-around;
      /deep/.el-carousel__container {
        height: 625px !important;
      }
      .swiper {
        width: 785px;
        height: 625px;
      }
      .contentWrap {
        width: 785px;
        height: auto;
        .pic {
          width: 785px;
          height: auto;
          img {
            width: 100%;
            height: auto;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 450px) {
  .anDetail {
    .mr {
      margin-right: 10px;
    }
    font-family: 微软雅黑, MicrosoftYaHei;
    .wrap {
      background: #f5f5f5;
    }
    .local {
      padding: 61 * 2px 0 52px;
      width: 1280px;
      margin: 0 auto;
      text-align: left;
      color: #004c31;
      font-size: 24 * 2px;
    }
    .swiper {
      padding: 1px;
      width: auto;
      margin: 0 auto;
      background: #ffffff;
      .title {
        text-align: left;
        margin: 45px 0 0 40px;
        font-size: 32 * 2px;
        font-weight: bold;
        color: #004c31;
      }
      .auth {
        padding: 23px 0 31px 40px;
        text-align: left;
        font-size: 14px;
        font-weight: 400;
        color: #6c7a77;
        border-bottom: 1px dotted #f5f5f5;
      }
      .swiperWrap {
        width: 1063 * 1.5px;
        height: 625 * 1.5px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-around;
        /deep/.el-carousel__container {
          height: 625px !important;
        }
        .arrow {
          width: 50px;
          height: 75px;
          img {
            width: 50px;
            height: 75px;
          }
        }
        .swiper {
          width: 785 * 1.5px;
          height: 625 * 1.5px;
        }
        .contentWrap {
          width: 785 * 1.5px;
          height: auto;
          .pic {
            width: 785 * 2px;
            height: auto;
            img {
              width: 100%;
              height: auto;
            }
          }
        }
      }
    }
  }
}
</style>
